import React from 'react';

import { gql } from '@apollo/client';
import { GoogleIcon, MicrosoftIcon } from '@modernloop/shared/icons';

import { DirectoryType, useDirectoryInfoQuery } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DirectoryInfoQuery = gql`
  query DirectoryInfo {
    thisOrg {
      id
      directoryType
      directoryIntegrations {
        id
        name
        type
      }
    }
  }
`;

type OrgDirectoryIntegration = {
  name: string;
  type: DirectoryType;
};

type DirectoryInfo = {
  type: DirectoryType | undefined;
  label?: string;
  loading: boolean;
  icon?: JSX.Element;
  calendarName?: string;
  directoryIntegrations?: OrgDirectoryIntegration[];
};

const useDirectoryInfo = (): DirectoryInfo => {
  const { data, loading } = useDirectoryInfoQuery();
  let label: string | undefined;
  let calendarName: string | undefined;
  let icon: JSX.Element | undefined;
  if (data?.thisOrg?.directoryType === DirectoryType.Google) {
    label = 'Google';
    calendarName = 'Google Calendar';
    icon = <GoogleIcon />;
  } else if (data?.thisOrg?.directoryType === DirectoryType.Outlook) {
    label = 'Microsoft';
    calendarName = 'Outlook Calendar';
    icon = <MicrosoftIcon />;
  } else if (data?.thisOrg?.directoryType === DirectoryType.MultiDomain) {
    const directoryIntegrations = data?.thisOrg?.directoryIntegrations ?? [];
    if (
      directoryIntegrations.length > 0 &&
      directoryIntegrations.every((integration) => integration.type === DirectoryType.Google)
    ) {
      calendarName = 'Google Calendar';
    } else if (
      directoryIntegrations.length > 0 &&
      directoryIntegrations.every((integration) => integration.type === DirectoryType.Outlook)
    ) {
      calendarName = 'Outlook Calendar';
    } else {
      calendarName = undefined;
    }
  }

  const directoryIntegrations = data?.thisOrg?.directoryIntegrations as OrgDirectoryIntegration[] | undefined;

  return {
    type: data?.thisOrg?.directoryType ?? undefined,
    label,
    loading,
    icon,
    calendarName,
    directoryIntegrations,
  };
};

export default useDirectoryInfo;
